// DeleteSection.js
import React, { useState } from 'react';
import { Trash2 } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { authenticatedFetch } from '../../utils/api';
import styles from './DeleteSection.module.css';

const DeleteSection = ({ presentationId }) => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isDeleting, setIsDeleting] = useState(false);
    const navigate = useNavigate();

    const handleDelete = async () => {
        try {
            setIsDeleting(true);
            await authenticatedFetch(`/api/presentation/${presentationId}`, {
                method: 'DELETE'
            });
            navigate('/recordings');
        } catch (error) {
            console.error('Error deleting presentation:', error);
            setIsDeleting(false);
        }
    };

    return (
        <>
            <div className={styles.deleteSection}>
                <div className={styles.deleteHeader}>
                    <h3 className={styles.deleteTitle}>Delete Presentation</h3>
                    <p className={styles.deleteDescription}>
                        Once you delete a presentation, there is no going back. Please be certain.
                    </p>
                </div>
                <button
                    className={styles.deleteButton}
                    onClick={() => setIsModalOpen(true)}
                    disabled={isDeleting}
                >
                    <Trash2 size={16} />
                    {isDeleting ? 'Deleting...' : 'Delete Presentation'}
                </button>
            </div>

            {isModalOpen && (
                <div className={styles.confirmationModal}>
                    <div className={styles.modalContent}>
                        <h4 className={styles.modalTitle}>Confirm Deletion</h4>
                        <p className={styles.modalText}>
                            Are you sure you want to delete this presentation? This action cannot be undone.
                        </p>
                        <div className={styles.modalActions}>
                            <button
                                className={styles.cancelButton}
                                onClick={() => setIsModalOpen(false)}
                                disabled={isDeleting}
                            >
                                Cancel
                            </button>
                            <button
                                className={styles.confirmButton}
                                onClick={handleDelete}
                                disabled={isDeleting}
                            >
                                {isDeleting ? 'Deleting...' : 'Delete'}
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};

export default DeleteSection;